import React from 'react';
import Header, { HeaderType } from '../../components/header';
import Content, { Color } from '../../components/content';
import Img404 from './img/img404.svg';

import Button, { ButtonType } from '../../components/common/button';
import './style.scss';

const NotFound: React.FC = () => {
  const COUNTRY_CODE = process.env.COUNTRY_CODE || '';
  return (
    <>
      <Header type={HeaderType.Default} />
      <Content color={COUNTRY_CODE === 'FI' ? Color.White : Color.Blue} center>
        <div styleName="notFound">
          <div styleName="notFound__center">
            <Img404 />
          </div>
          <Button
            style={{ maxWidth: '300px' }}
            type={ButtonType.Submit}
            label="BACK TO THE MAIN PAGE"
            onClick={() => {
              document.location.href = '/';
            }}
          />
        </div>
      </Content>
    </>
  );
};
export default NotFound;
